import { Box } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { FocusLeePlaceholderImage } from '../common/FocusLeePlaceholderImage';

export const ActivityEmptyState = () => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '300px',
            padding: '20px'
        }}>
            <FocusLeePlaceholderImage kind="activity" />
            <Text style={{ 
                marginTop: '10px', 
                color: 'var(--tg-theme-hint-color)',
                fontSize: '16px'
            }}>
                No activity to show yet...
            </Text>
        </Box>
    );
}; 
